const createRecursiveFunction = (callback, options)=>{
    const fn = ()=>{
        if (options.condition()) callback();
        else setTimeout(fn, options.optTimeout || 1000);
    };
    return fn;
};
const src_createRecursiveFunction = createRecursiveFunction;
export default src_createRecursiveFunction;
